import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'app/components/core/ProgressBar';
import { DialogType, StatusDialog } from 'app/components/composite/StatusDialog';
import { Spinner } from 'app/components/core/Spinner';
import * as styles from './StartUp.css';

export function StartUp({
    startupProgress = 0,
    startupError = null,
    onInitiateKeycloak,
    isUserFullyAuthenticated
}) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!isUserFullyAuthenticated) {
            onInitiateKeycloak();
        }
    }, [isUserFullyAuthenticated, onInitiateKeycloak]);

    if (startupError) {
        const { title, message } = startupError;
        return (
            <StatusDialog
                testId="error-details-dialog"
                title={t(title)}
                message={t(message)}
                type={DialogType.ERROR}
                onSubmit={() => window.location.reload()}
            />
        );
    }

    return (
        <Spinner className={styles.base} testId="start-screen">
            {t('common:initiating')}
            <ProgressBar progressValue={startupProgress} className={styles.progress} />
        </Spinner>
    );
}

StartUp.propTypes = {
    startupProgress: PropTypes.number,
    startupError: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string
    }),
    isUserFullyAuthenticated: PropTypes.bool.isRequired,
    onInitiateKeycloak: PropTypes.func.isRequired
};
